module.exports = __webpack_public_path__ + "static/img/product.a69732f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/product.jpg
// module id = DQHQ
// module chunks = 11